<!--
@component
Headline

See markup below.
-->

<script lang="ts">
  import Logo from '$lib/components/common/Logo/index.svelte';
  import { Headline as GraphicsHeadline } from '@reuters-graphics/graphics-components';

  interface HeadlineContent {
    hed: string;
  }

  interface Props {
    content: HeadlineContent;
  }

  /* Content from storyboard */
  const { content }: Props = $props();
</script>

<GraphicsHeadline width="wide" class="!fmt-3">
  {#snippet hed()}
    <h1 class="custom-hed">
      <span class="logo-wrap" aria-hidden="true">
        <a href="https://www.reuters.com/sports/world-cup/">
          <Logo />
        </a>
      </span>
      <span class="visually-hidden title leading-none text-secondary">
        {@html content}
      </span>
    </h1>
  {/snippet}
</GraphicsHeadline>

<style lang="scss">
  .custom-hed {
    margin: 0;
  }
  .logo-wrap {
    display: block;
    margin-inline: auto;
    max-width: fit-content;
  }
  a {
    text-decoration: none;
  }
</style>
